import { render, staticRenderFns } from "./EditEventGroup.vue?vue&type=template&id=8899d38e&scoped=true&"
import script from "./EditEventGroup.vue?vue&type=script&lang=js&"
export * from "./EditEventGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditEventGroup.vue?vue&type=style&index=0&id=8899d38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8899d38e",
  null
  
)

export default component.exports